import { render, staticRenderFns } from "./FormSwitcher.vue?vue&type=template&id=300140f4&scoped=true&"
import script from "./FormSwitcher.vue?vue&type=script&lang=js&"
export * from "./FormSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./FormSwitcher.vue?vue&type=style&index=0&id=300140f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300140f4",
  null
  
)

export default component.exports